import { Component, ViewChild, ElementRef  } from '@angular/core';
import { NavController,NavParams,AlertController,ViewController,App,LoadingController, Loading} from 'ionic-angular';
import { AuthService } from '../../providers/auth';
//import { NavController,Tabs,Loading,LoadingController } from 'ionic-angular';
import { HomePage } from '../../pages/home/home';
import { NgStyle } from '@angular/common';
import { DetailPage } from '../../pages/detail/detail';
import { RidePage } from '../../pages/ride/ride';


@Component({
  selector: 'page-list',
  templateUrl: 'list.html'
})
export class ListPage {
    loading: Loading;
  item: any;
  items: any;
  savedata: boolean = true;
  obj:any;
  pet : any;
    
  //icons: string[];
  //items: Array<{title: string, note: string, icon: string}>;

  constructor(public loadingCtrl: LoadingController,private alertCtrl: AlertController,public navCtrl: NavController,public authService:AuthService,public navParams: NavParams) {
    this.items = navParams.get('data');
    this.pet = 'All';
  }

  login={"company_id":localStorage.getItem('company_id')};
  ionViewDidLoad() {    this.holauftrag();    }

  holauftrag(){
    this.loading = this.loadingCtrl.create({ content: '', });
    let data_parameters= this.login;
    let method='leerauftrag.php';
    //console.log(this.login);
   
    this.authService.postData(data_parameters,method).then((result) => {
      this.loading.present();
      this.obj = result;
      console.log(this.obj);
      
     if(this.obj.status=='true'){
      this.loading.dismiss();
       this.items=this.obj.response[0].leerauftrag;
       console.log(this.items);
      }
     
     else{
      this.loading.dismiss();
      //alert(this.obj.message);
      }
      
      }, (err) => {
        // Error log
    });
  
  }
 
  
  neuauftrag(fahrtid){
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.loading = this.loadingCtrl.create({
              content: 'Bitte warten..',
              });
              this.loading.present();
              setTimeout(() => {
                this.loading.dismiss();
              }, 500);
         // this.loading = this.loadingCtrl.create({content: '', });
            let updaterate={"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"fahrzeug":localStorage.getItem('car_number'),"artid":fahrtid}
                    let data_parameters=updaterate;
                    console.log(data_parameters);
                    let method='leerauftrag_save.php';
                    this.authService.postData(data_parameters,method).then((result) => {
                      this.loading.present();
                      this.obj = result;
                      console.log(this.obj);
                      
                    if(this.obj.status=='true'){
                    //alert(this.obj.message);
                    //this.savedata=true;
                    //this.navCtrl.push(ListPage);
                      let alert = this.alertCtrl.create({
                        title: 'Nachricht',
                        subTitle: this.obj.message,
                        buttons: ['OK']
                      });
                      alert.present();
                      this.navCtrl.push(HomePage);
                      }
                    
                    else{
                        console.log("Fehler!");
                  
                      }
                      
                      }, (err) => {
                        // Error log
                    }); 
                  }
                }
              ]
            });
            alert.present();
  }
  



}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts